  <input type="text" nz-input [(ngModel)]="searchName" placeholder="VPS Group Name" style="width: 40%; margin-right: 8px;" />
  <input type="text" nz-input [(ngModel)]="searchId" placeholder="ID" style="width: 40%; margin-right: 8px;" />

  <button nz-button nzType="primary" (click)="onSearch()">Search</button>


<nz-table
  #tableRef
  [nzData]="stageGroups"
  [nzLoading]="loading"
  [nzSize]="'small'"
  [nzShowPagination]="true"
  [nzPageSize]="5"
>
  <thead>
    <tr>
      <th>ID</th>
      <th>Name</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of tableRef.data; trackBy: trackById">
      <td>{{ item.id }}</td>
      <td>{{ item.name }}</td>
      <td>
        <button nz-button nzType="link" (click)="showGroupDetail(item)">Focus On</button>
      </td>
    </tr>
  </tbody>
</nz-table>
